import styled from 'styled-components';
import { memo, MouseEvent } from 'react';
import Spinner from 'components/common/loaders/spinner';
import { useMixpanel, useLoading } from 'src/hooks';
import { ButtonProps } from 'types/buttons';
import buttonStyle from './button-styles';

const StyledButton = memo(styled.button`
  ${buttonStyle}
`);

const ButtonSpinner = styled(Spinner)`
  width: 22px;
  height: 22px;
  position: absolute;
  left: 50%;
  margin-left: -11px;
  top: 50%;
  margin-top: -11px;
  border-width: 3px;
  border-top-width: 3px;
  border-color: ${props => props.theme.colors.white};
  border-top-color: ${props => props.theme.colors.siteBlue};
`;

export const Button = ({
  mixpanelProps,
  onClick,
  className,
  submit,
  children,
  ids,
  isLoading,
  disabled,
  ...props
}: ButtonProps) => {
  const { logToMixpanel, incrementPeople } = useMixpanel();
  const [checkIsLoading] = useLoading();

  const loading = isLoading || (ids && ids.length > 0 && checkIsLoading(ids));

  const onClickAction = (e: MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(e);
    }
    if (mixpanelProps && mixpanelProps.object) {
      logToMixpanel(mixpanelProps.object);
    }
    if (mixpanelProps && mixpanelProps.people) {
      incrementPeople(mixpanelProps.people as string);
    }
  };
  return (
    <StyledButton
      className={className}
      disabled={disabled || loading}
      type={submit ? 'submit' : 'button'}
      onClick={onClickAction}
      onKeyPress={(e: any) => submit && e.key === 'Enter' && onClickAction(e)}
      {...props}
    >
      {loading && (
        <>
          <ButtonSpinner />
          {children}
        </>
      )}
      {!loading && children}
    </StyledButton>
  );
};

export default Button;
